import { TireQuoteRecordCustomer } from '@navio/nsdk';
import { noddiAsync, URLKeys } from 'noddi-async';
import { customerRoutes } from 'noddi-util';
import { Navigate, useParams } from 'react-router-dom';
import { ApiErrorPageWithTrans } from '../Error/ApiErrorPageWithTrans';
import { NoddiLoadingScreenWithTrans } from '../Loading/NoddiLoadingScreenWithTrans';

export const RedirectToStatusOrShowOfferStepWrapper = ({
  children
}: {
  children: (tireOffer: TireQuoteRecordCustomer) => React.ReactNode;
}) => {
  const { slug } = useParams() as { slug: string };
  const {
    data: tireOffer,
    isPending: isTireOfferPending,
    error: tireOfferError
  } = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: { carTireQuoteSlug: slug },
    queryConfig: { staleTime: Infinity }
  });

  if (isTireOfferPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (tireOfferError) {
    return <ApiErrorPageWithTrans error={tireOfferError} />;
  }

  // If the tire offer has been selected, show the status page
  if (tireOffer.selectedAt) {
    return <Navigate to={customerRoutes.tireOfferStatus.getPath({ slug })} />;
  }
  return children(tireOffer);
};
